export default __webpack_public_path__ + "static/media/HONOR.ad377e56.png";